import { SORT } from "Pages/GMS/Products/constants";

class Utils {
  static isEmpty(value) {
    return (
      value === null || value === undefined || value.toString().trim() === ""
    );
  }

  static getListFromCommaSeparatedString(str) {
    if (this.isEmpty(str)) return [];
    return this.parseCsvValues(str);
  }

  /**
   * Parse a CSV string per RFC 4180 rules.
   * Quoted values preserve internal commas as part of the value.
   * e.g. '"Red, Blue",Green' -> ['Red, Blue', 'Green']
   *      'Red, Blue, Green'  -> ['Red', 'Blue', 'Green']
   *
   * Mirrors backend parse_csv_values(keep_empty=False).
   * @param {string} val
   * @param {boolean} keepEmpty - When true, preserves empty entries so "A,,B" → ["A","","B"].
   *                              When false (default), empty entries are filtered out.
   * @returns {string[]}
   */
  static parseCsvValues(val, keepEmpty = false) {
    if (val === null || val === undefined) return [];
    val = String(val).trim();
    if (val === "") return [];

    // Strict RFC 4180 parser: " only opens quoting at field start.
    // This correctly splits 1",2" into ['1"', '2"'] (inch notation)
    // while still handling "a,b" as a single quoted field ['a,b'].
    const result = [];
    let current = "";
    let inQuotes = false;
    let fieldStart = true;
    let i = 0;

    while (i < val.length) {
      const ch = val[i];
      if (inQuotes) {
        if (ch === '"') {
          if (i + 1 < val.length && val[i + 1] === '"') {
            current += '"';
            i += 2;
          } else {
            inQuotes = false;
            i++;
          }
        } else {
          current += ch;
          i++;
        }
      } else {
        if (ch === '"' && fieldStart) {
          inQuotes = true;
          fieldStart = false;
          i++;
        } else if (ch === ",") {
          result.push(current.trim());
          current = "";
          fieldStart = true;
          i++;
        } else {
          current += ch;
          fieldStart = false;
          i++;
        }
      }
    }
    result.push(current.trim());
    return keepEmpty ? result : result.filter((v) => v !== "");
  }

  /**
   * Join values into a CSV string per RFC 4180 rules.
   * Values containing commas or double quotes are enclosed in double quotes.
   * This is the inverse of parseCsvValues — round-trip safe.
   * e.g. ['Red, Blue', 'Green'] -> '"Red, Blue",Green'
   */
  static joinCsvValues(values) {
    if (!values || values.length === 0) return "";
    return values
      .map((v) => {
        const s = String(v);
        if (s.includes(",")) {
          return '"' + s.replace(/"/g, '""') + '"';
        }
        return s;
      })
      .join(",");
  }

  static getUTCDateString(d) {
    function pad(n) {
      return n < 10 ? "0" + n : n;
    }
    return (
      d.getUTCFullYear() +
      "-" +
      pad(d.getUTCMonth() + 1) +
      "-" +
      pad(d.getUTCDate()) +
      "T" +
      pad(d.getUTCHours()) +
      ":" +
      pad(d.getUTCMinutes()) +
      ":" +
      pad(d.getUTCSeconds())
    );
  }

  static getDate(dateString) {
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");

    return month + "/" + day + "/" + year;
  }

  static round(num) {
    if (this.isUndefinedOrNull(num)) return null;
    if (this.isEmpty(num)) return null;
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
  }

  static isUndefinedOrNull(value) {
    return value === null || value === undefined;
  }

  static capitalizeFirstLetter(str) {
    const words = str.split(" ");

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(" ");
  }

  static appendLeadingZeroes(n) {
    if (n <= 9) {
      return "0" + n;
    }
    return n;
  }

  static get_current_root_url() {
    return window.location.origin + "/";
  }

  static async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static SetWindowTitle(title) {
    window.document.title = "SMARTSTUDIO : " + title;
    // window.document.title = "GMS : " + title;
  }

  static run_initial_js() {
    //window["run_initial_js"]();
  }

  static generate_guid() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  static check_frame_is_loaded(frameid, callbackmethod) {
    window["check_frame_is_loaded"](frameid, callbackmethod);
  }

  static click_button(buttonid) {
    window["click_button"](buttonid);
  }

  static borderStyle() {
    return { height: "2.6875rem", border: "1px solid #c9cccf" };
  }

  static generate_file_name(length) {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static run_callback_on_click_outside_ref(e, ref, callback){
    if(ref.current && !ref.current.contains(e.target)) callback()
  }

  /**
   * Validate form fields
   *
   * @param {object} fields
   * @param {object} options
   *
   * ----------------------------------------------------------------
   *
   * *example*:
   * Utils.validate(
   * fields,
   * options = {
   * name: {required: true, minLength: 2, maxLength: 65, type: "alphanumeric"}
   * }
   * )
   *
   * options:
   * required: boolean,
   * minLength: number,
   * maxLength: number,
   * type: alnum_with_spaces|alnum|number
   *
   * ----------------------------------------------------------------
   * @returns {boolean}
   */
  static validate(
    fields,
    options = null
  ){
    if(!fields || !options) return true
    let flag = [true, ""]
    const alphanumeric = /^[\w\s-\[\]\(\)]+$/; // alphanumberic regex
    const alphanumericWithDots = /^[\w\s.\-\[\]\(\)&/%]+$/; // alphanumeric with allowed symbols
    const numeric = /^\d+$/

    Object.entries(options).map(([fieldName, option], key) => {
      const fieldValue = fields[fieldName]
      const displayName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1)

      if(option.required && (!fieldValue || (typeof fieldValue == "string" && fieldValue?.trim() == "") || fieldValue?.length === 0))
        flag = [false, `${displayName} is required`]

      else if(option.type === "alnum_with_spaces" && (!alphanumeric.test(fieldValue) || numeric.test(fieldValue)))
        flag = [false, `${displayName} should be alphanumeric with spaces, no special characters allowed`]

      else if(option.type === "alnum_with_spaces_dots" && (!alphanumericWithDots.test(fieldValue) || numeric.test(fieldValue)))
        flag = [false, `${displayName} must be 2-60 characters long. Allowed characters: letters, numbers, spaces, and these symbols: & / () [] % - _ .`]

      else if(option.type === "alnum" && fieldValue && (!alphanumeric.test(fieldValue) || numeric.test(fieldValue)))
        flag = [false, `${displayName} should be alphanumeric, no special characters or spaces allowed`]

      else if(option.type === "number" && fieldValue && (!numeric.test(fieldValue)))
        flag = [false, `${displayName} should be a number`]

      if(option.minLength && fieldValue?.length < option.minLength)
        flag = [false, `${displayName} should contain atleast ${option.minLength} characters`]

      if(option.maxLength && fieldValue?.length > option.maxLength)
        flag = [false, `${displayName} should be less than ${option.maxLength} characters`]
    })

    return flag
  }

  /**
   * Attribute columns for a DeltaTable.
   *
   * `customNames` (AB#14859) is the endpoint's `custom_columns` — the attribute names an SME
   * ticked "Mark as custom attribute". It is optional on purpose: three tables fed by three
   * different endpoints share this helper, and the ones with no custom data call it with one
   * argument exactly as before.
   */
  static generateHeadersFromArray(arr, customNames){
    const custom = customNames instanceof Set ? customNames : new Set(customNames ?? [])
    return arr.reduce((acc, item) => [...acc, {name: item, column: item, options: { isAttributeColumn: true, isCustom: custom.has(item) }}], [])
  }

  static sortChoices (
    sort,
    type,
    getNameCallBack,
    disabledCallback,
    ) {
      if(!sort) return () => true
      return (item1, item2) => {
        const a = getNameCallBack(item1).replace('"', '').split(' ')[0]
        const b = getNameCallBack(item2).replace('"', '').split(' ')[0]
        if(type === SORT.SEPARATE_ASC || !type)
          return (
              (disabledCallback && (disabledCallback(item1)) - (disabledCallback(item2))) || // disabled
              ((!isNaN(+a) && !isNaN(+b)) ? +a - +b : 0) || // if both are number
              ((!isNaN(+a) && isNaN(+b)) && 0) || // if 1st is number
              (isNaN(+a) && !isNaN(+b) && 1) || // if 2nd is number
              (isNaN(+a) && isNaN(+b) && a.localeCompare(b) || 0 // if both are string
          ))
        if(type === SORT.SEPARATE_DESC)
          return (
            (disabledCallback && (disabledCallback(item1)) - (disabledCallback(item2))) || // disabled
            ((!isNaN(+a) && !isNaN(+b)) ? +b - +a : 0) || // if both are number
            ((!isNaN(+a) && isNaN(+b)) && 1) || // if 1st is number
            (isNaN(+a) && !isNaN(+b) && 0) || // if 2nd is number
            (isNaN(+a) && isNaN(+b) && b.localeCompare(a) || 0 // if both are string
          ))
        if(type === SORT.ASC)
          return (
            ((!isNaN(+a) && !isNaN(+b)) ? +a - +b : 0) || // if both are number
            ((!isNaN(+a) && isNaN(+b)) && 0) || // if 1st is number
            (isNaN(+a) && !isNaN(+b) && 1) || // if 2nd is number
            (isNaN(+a) && isNaN(+b) && a.localeCompare(b) || 0 // if both are string
          ))
        if(type === SORT.DESC)
          return (
            ((!isNaN(+a) && !isNaN(+b)) ? +b - +a : 0) || // if both are number
            ((!isNaN(+a) && isNaN(+b)) && 1) || // if 1st is number
            (isNaN(+a) && !isNaN(+b) && 0) || // if 2nd is number
            (isNaN(+a) && isNaN(+b) && b.localeCompare(a) || 0 // if both are string
          ))
        }

      }


    static generateFiltersFromObject(filters) {
      if(!filters) return

      return Object.keys(filters)
      .filter((key) => !!filters[key])
      .map(key => key + '=' + (typeof filters[key] !== 'object' ? filters[key] : (filters[key].toString()))).join('&')
    }


    static getDeltaValue({live, draft, rollback}) {
      if (live != null)
          return {...live, delta_type: "live"};

      if (draft != null)
          return {...draft, delta_type: "draft"};

      if (rollback != null)
          return {...rollback, delta_type: "rollback"};
  }
}


export default Utils;
